var _rect, _path, _polygon, _path2, _path3, _circle, _path4, _path5, _path6, _polygon2, _polygon3, _path7, _polygon4, _path8, _path9, _circle2, _rect2, _path10, _path11, _g, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawLandscapeModeReR964(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1005.31822,
    height: 465,
    viewBox: "0 0 1005.31822 465",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 384.58641,
    width: 981.69583,
    height: 2.47715,
    fill: "#cbcbcb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1102.65911,411.04688c0,85.182-50.63935,114.92434-113.10611,114.92434S876.44689,496.22883,876.44689,411.04688,989.553,217.5,989.553,217.5,1102.65911,325.8649,1102.65911,411.04688Z",
    transform: "translate(-97.34089 -217.5)",
    fill: "#f1f1f1"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "888.092 295.441 889.251 224.152 937.459 135.956 889.432 212.968 889.952 180.913 923.178 117.105 890.091 172.43 890.091 172.43 891.027 114.779 926.605 63.98 891.174 105.713 891.759 0 888.082 139.945 888.384 134.172 852.211 78.803 887.803 145.255 884.434 209.642 884.333 207.933 842.632 149.666 884.207 213.97 883.785 222.023 883.71 222.143 883.744 222.804 875.193 386.16 886.618 386.16 887.989 301.783 929.461 237.637 888.092 295.441",
    fill: "#e5e5e5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M346.69505,221.41052v4.28269H229.37228A67.90322,67.90322,0,0,0,161.469,293.59635V542.16067a67.90324,67.90324,0,0,0,67.903,67.90344H873.01413a67.90324,67.90324,0,0,0,67.90331-67.90317V293.59669a67.9032,67.9032,0,0,0-67.903-67.90345h-442.807v-4.28268Z",
    transform: "translate(-97.34089 -217.5)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.84605,240.14612H872.541a50.71258,50.71258,0,0,1,50.71172,50.71171V540.61448A50.71264,50.71264,0,0,1,872.541,591.32619H229.84605a50.7127,50.7127,0,0,1-50.71171-50.71171V510.31589a24.10455,24.10455,0,0,0,33.1902-22.30884V345.60723a24.10462,24.10462,0,0,0-33.1902-22.30888V290.8578A50.71261,50.71261,0,0,1,229.84605,240.14612Z",
    transform: "translate(-97.34089 -217.5)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 321.07084,
    cy: 138.65862,
    r: 51.58827,
    fill: "#ff6583"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M642.23444,591.92679H293.02482a7.12487,7.12487,0,0,1-1.305-.10338l165.16007-286.081a11.56407,11.56407,0,0,1,20.12981,0l110.84316,191.9825,5.3103,9.18641Z",
    transform: "translate(-97.34089 -217.5)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "544.893 374.426 425.665 374.426 484.194 289.411 488.406 283.287 490.512 280.225 495.822 289.411 544.893 374.426",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M836.67186,591.92679H534.6342l58.529-85.01549,4.21193-6.12432L673.6436,389.9955c5.00018-7.2612,17.02891-7.71335,22.90762-1.36954a13.78648,13.78648,0,0,1,1.09829,1.36954Z",
    transform: "translate(-97.34089 -217.5)",
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M251.15678,460.99618a10.74269,10.74269,0,0,1,3.06875-16.18426l23.222-95.04913,16.94053,5.4078L269.31231,449.571a10.80091,10.80091,0,0,1-18.15553,11.42515Z",
    transform: "translate(-97.34089 -217.5)",
    fill: "#9f616a"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "165.818 182.699 178.198 193.379 195.519 208.309 203.168 169.169 203.968 165.099 204.599 161.869 187.048 131.299 172.418 132.139 171.418 132.199 171.398 132.419 171.168 134.469 168.168 161.449 168.098 162.099 165.818 182.699",
    fill: "#cbcbcb"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "246.737 452.373 258.997 452.373 264.829 405.085 246.735 405.086 246.737 452.373",
    fill: "#9f616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M340.95063,665.87054l24.144-.001h.001a15.38731,15.38731,0,0,1,15.38648,15.38624v.5l-39.53076.00146Z",
    transform: "translate(-97.34089 -217.5)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "118.737 451.373 130.997 451.373 136.829 404.085 118.735 404.086 118.737 451.373",
    fill: "#9f616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M212.95063,664.87054l24.14405-.001h.001a15.38731,15.38731,0,0,1,15.38648,15.38624v.5l-39.53076.00146Z",
    transform: "translate(-97.34089 -217.5)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M206.27937,648.049l33,5,48.00977-162.48,50.99023,163.48,37-5-48-190v-15l-6.5-22.5.68018-6.09,4.73-42.59,2.04981-18.47.13285-1.19313a4.0555,4.0555,0,0,0-3.19291-4.41685v0l-15.39991-3.24H284.60945l-14.8501,4.09-1.02.28-.46.13.23,1.92,3.48,29.18.18994,1.6,3.3601,28.12994.74,6.17c-29,21-30,42-30,42Z",
    transform: "translate(-97.34089 -217.5)",
    fill: "#cbcbcb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.89518,
    cy: 90.83636,
    r: 24.56103,
    fill: "#9f616a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 273.77937,
    y: 414.54895,
    width: 49,
    height: 7,
    transform: "matrix(-0.99156, -0.12967, 0.12967, -0.99156, 442.48992, 653.74694)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197,419.85133a10.52534,10.52534,0,0,0-1.31643,1.00712l-48.05635-12.2506-3.27839-11.59339-18.14315,2.66087,3.80921,21.08783a8,8,0,0,0,7.03474,6.53394l56.11129,5.90907a10.49709,10.49709,0,1,0,3.83908-13.35484Z",
    transform: "translate(-97.34089 -217.5)",
    fill: "#9f616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M314.27937,355.049l8.5-6.5c2.29817-.87171,5.44731,1.605,6,4l12,49-25,18-3.5-5.5Z",
    transform: "translate(-97.34089 -217.5)",
    fill: "#cbcbcb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.50935,378.94892a67.67834,67.67834,0,0,0,6.48,2.2c.7.21,1.41992.41,2.12988.6a66.01843,66.01843,0,0,0,14.34033,2.31994,45.1399,45.1399,0,0,0,6.25977-.17,35.24193,35.24193,0,0,0,6.58984-1.3c.07031-.02.15039-.04.22021-.06a28.90608,28.90608,0,0,0,11.9502-6.79,23.55972,23.55972,0,0,0,2.10986-2.35,21.2388,21.2388,0,0,0,4.56006-16.53,14.15326,14.15326,0,0,0-.34033-1.57,25.10742,25.10742,0,0,0-1.48975-4.1c-.27-.62-.57031-1.23-.89013-1.83l-11.29981-3.82h-21.52l-14.8501,4.09-1,.06-.02.22-.46.13.23,1.92Z",
    transform: "translate(-97.34089 -217.5)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M319.05645,288.00236c4.59329-.56305,9.634-.16485,13.21411,2.76739s4.73558,9.0278,1.34592,12.17829c-3.00083,2.78909-7.69329,2.13322-11.71262,2.92632a15.85417,15.85417,0,0,0-12.38363,15.15656c.05982,10.17413,9.82411,17.879,11.578,27.90094,1.197,6.83982-1.68772,14.03818-6.675,18.86965s-11.84323,7.44256-18.7509,8.1498-13.8926-.37294-20.60575-2.14766c-6.74127-1.78215-13.3778-4.31054-19.03424-8.388s-10.2931-9.82559-12.10928-16.55777-.51227-14.45088,4.16774-19.61986c5.35905-5.919,14.27436-7.95446,18.90989-14.45564,5.19639-7.28779,3.27352-17.66626,7.4792-25.56731,2.80791-5.27513,8.12457-8.87314,13.79191-10.76857s11.719-2.26954,17.69212-2.45311c3.13956-.09649,6.37527-.12862,9.30035,1.016s5.49633,3.75317,5.648,6.89055S319.05645,288.00236,319.05645,288.00236Z",
    transform: "translate(-97.34089 -217.5)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M150.78679,682.5h277a1,1,0,1,0,0-2h-277a1,1,0,0,0,0,2Z",
    transform: "translate(-97.34089 -217.5)",
    fill: "#cbcbcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawLandscapeModeReR964);
export default __webpack_public_path__ + "static/media/undraw_landscape_mode_re_r964.cababb1d9ccfee52d8cb8771aa12ff48.svg";
export { ForwardRef as ReactComponent };